import * as React from 'react';
import { useSelector } from 'react-redux';

import { getButtonTextByReferrer } from './getButtonTextByReferrer';
import { IBackToPageContainerContextProps } from '../types';
import { selectPage } from '../../../selectors/selectPage';

export const useButtonProps = ({ backBtnTexts }: IBackToPageContainerContextProps) => {
  const { referrer } = useSelector(selectPage);
  const text = React.useMemo(() => {
    return getButtonTextByReferrer({ referrer, backBtnTexts });
  }, [referrer, backBtnTexts]);

  return { href: referrer, text };
};
